<template>
    <div class="search-results__filters-section">
        <div class="search-results__filters-section-label" @click="sectionVisible = !sectionVisible">
            <h4 class="search-results__filters-section-title">Colour</h4>
            <div class="search-results__filters-section-summary">{{ selectedSummary }}</div>
            <img src="/images/used/filters-arrow.svg" class="search-results__filters-section-arrow" :class="{ 'search-results__filters-section-arrow--open': sectionVisible }" />
        </div>
        <div class="search-results__filters-section-content search-results__filters-section-content--colours" :class="{ 'search-results__filters-section-content--hidden': !sectionVisible }">
            <template v-for="(option, index) in availableOptions">
                <div :key="index">
                    <input class="redesign-checkbox__input search-results__filters-section-colour-checkbox" type="checkbox" :id="uid + index" :value="option.value" v-model="selectedValue" />
                    <label class="search-results__filters-section-colour-label" :for="uid + index" :title="option.label">
                        <div class="search-results__filters-colour" :title="option.label" :style="option.colour"></div>
                    </label>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            sectionVisible: false,
        };
    },
    methods: {
        shortenColourName(colour) {
            let maxLength = colour.length - 8;

            if (colour.startsWith('other')) {
                maxLength = 5;
            }

            return colour.substring(0, maxLength);
        }
    },
    computed: {
        ...mapGetters({
            userOptions: 'UsedSearchOptions/userOptions',
        }),
        selectedSummary() {
            const selectedValuesLength = this.selectedValue.length;
            if (selectedValuesLength == 0) {
                return '';
            }
            if (selectedValuesLength == 1) {
                return this.shortenColourName(this.selectedValue[0]);
            }
            let summary = this.shortenColourName(this.selectedValue[0]);
            for (let index = 1; index < selectedValuesLength; index++) {
                summary = summary + ', ' + this.shortenColourName(this.selectedValue[index]);
                if (index > 2) {
                    const remainder = selectedValuesLength - index - 1;
                    if (remainder > 0) {
                        summary = summary + ' and ' + remainder +' more';
                    }
                    break;
                }
            }
            if (String(summary).length > 20) {
                return selectedValuesLength + ' items';
            }
            return summary;
        },
        availableOptions() {
            const availableOptions = this.$store.state.UsedSearchOptions.options.colour;
            if (!availableOptions) {
                return [];
            }

            return availableOptions.map(availableOption => {
                if (availableOption == null) {
                    return {
                        value: 'Unlisted',
                        colour: {background: 'linear-gradient(90deg, rgba(255,0,0,1) 0%, rgba(255,235,0,1) 15%, rgba(56,255,0,1) 33%, rgba(0,255,213,1) 50%, rgba(0,33,242,1) 65%, rgba(199,0,248,1) 82%, rgba(255,0,0,1) 100%);'},
                        label: 'Unlisted',
                    };
                }

                if (availableOption == 'other{null}') {
                    return {
                        value: availableOption,
                        colour: {background: `linear-gradient(90deg, rgba(255,0,0,1) 0%, rgba(255,235,0,1) 15%, rgba(56,255,0,1) 33%, rgba(0,255,213,1) 50%, rgba(0,33,242,1) 65%, rgba(199,0,248,1) 82%, rgba(255,0,0,1) 100%)`},
                        label: 'other',
                    };
                }

                const length = availableOption.length;
                return {
                    value: availableOption,
                    colour: {['background-color']: '#' + availableOption.substring(length -7, length -1)},
                    label: this.shortenColourName(availableOption),
                };
            });
        },
        selectedValue: {
            get() {
                return this.userOptions.colour;
            },
            set (value) {
                this.gaTag('Used Vehicles - Refine Search', 'Interaction', 'Colour');
                this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {
                    colour: value,
                });
            }
        },
        uid() {
            return 'colour.' + this._uid;
        }
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/UsedSearchResultsColourFilter.vue